var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticket-component" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: { paths: [{ title: _vm.$t("message.ticket") }], select: true },
        },
        [
          _vm.tabIndex === 1
            ? _c("div", { staticClass: "d-flex" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.timeSelect,
                        expression: "timeSelect",
                      },
                    ],
                    staticClass: "mr-1",
                    attrs: { id: "time-select" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.timeSelect = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "today" } }, [
                      _vm._v(_vm._s(_vm.$t("time.today"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "yesterday" } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("time.yesterday")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "current-week" } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("time.currentWeek")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "last-week" } }, [
                      _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "current-month" } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("time.currentMonth")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "last-month" } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("time.lastMonth")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "last-30" } }, [
                      _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "all-time" } }, [
                      _vm._v(_vm._s(_vm.$t("time.allTime"))),
                    ]),
                  ]
                ),
              ])
            : _c(
                "div",
                { staticClass: "chatListSettingContainer" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedTopic,
                          expression: "selectedTopic",
                        },
                      ],
                      attrs: { id: "topic-select" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedTopic = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "all" } }, [
                        _vm._v(_vm._s(_vm.$t("message.allTags"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.topics, function (topic) {
                        return _c("option", { domProps: { value: topic } }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(topic) +
                              "\n                "
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "custom-checkbox2",
                      staticStyle: { "margin-left": "6px" },
                      attrs: { content: _vm.$t("message.showMyChats") },
                    },
                    [
                      _c(
                        "a-switch",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.showMyTicket,
                            callback: function ($$v) {
                              _vm.showMyTicket = $$v
                            },
                            expression: "showMyTicket",
                          },
                        },
                        [
                          _c("a-icon", {
                            attrs: { slot: "checkedChildren", type: "check" },
                            slot: "checkedChildren",
                          }),
                          _vm._v(" "),
                          _c("a-icon", {
                            attrs: { slot: "unCheckedChildren", type: "close" },
                            slot: "unCheckedChildren",
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("message.showMyChats"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabIndex === 0
                    ? _c(
                        "a-button",
                        {
                          staticClass: "actionButtonBreadcrumb",
                          staticStyle: { "margin-right": "8px" },
                          on: { click: _vm.showModal },
                        },
                        [
                          _c("md-icon", [_vm._v("add")]),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.addNewStatus")) +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabIndex === 0
                    ? _c(
                        "a-button",
                        {
                          staticClass: "actionButtonBreadcrumb",
                          staticStyle: { "margin-right": "8px" },
                          on: { click: _vm.statusShowModal },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.listStatuses")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "position-relative pt-3",
          staticStyle: { padding: "0 30px" },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { span: "12" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "menu-button-base",
                          class: {
                            "menu-button": _vm.tabIndex !== 0,
                            "selected-link": _vm.tabIndex === 0,
                          },
                          on: {
                            click: function ($event) {
                              _vm.tabIndex = 0
                            },
                          },
                        },
                        [
                          _c("OfflineSupWaiting", {
                            staticStyle: {
                              "margin-bottom": "-1px",
                              width: "1.25em",
                              "margin-right": "1em",
                            },
                            attrs: {
                              fill: _vm.tabIndex === 0 ? "#03a9f4" : "#808184",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "4px" } },
                            [_vm._v(_vm._s(_vm.$t("message.waitingReply")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "menu-button-base",
                          class: {
                            "menu-button": _vm.tabIndex !== 1,
                            "selected-link": _vm.tabIndex === 1,
                          },
                          on: {
                            click: function ($event) {
                              _vm.tabIndex = 1
                            },
                          },
                        },
                        [
                          _c("ArchiveIcon", {
                            staticStyle: {
                              "margin-bottom": "-1px",
                              width: "1.25em",
                              "margin-right": "1em",
                            },
                            attrs: {
                              fill: _vm.tabIndex === 1 ? "#03a9f4" : "#808184",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "4px" } },
                            [_vm._v(_vm._s(_vm.$t("message.archive")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "menu-button-base",
                          class: {
                            "menu-button": _vm.tabIndex !== 2,
                            "selected-link": _vm.tabIndex === 2,
                          },
                          on: {
                            click: function ($event) {
                              _vm.tabIndex = 2
                            },
                          },
                        },
                        [
                          _c("ArchiveIcon", {
                            staticStyle: {
                              "margin-bottom": "-1px",
                              width: "1.25em",
                              "margin-right": "1em",
                            },
                            attrs: {
                              fill: _vm.tabIndex === 2 ? "#03a9f4" : "#808184",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "4px" } },
                            [_vm._v(_vm._s(_vm.$t("ticket.ticketForwarding")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("a-col", { attrs: { span: "24" } }, [
                _vm.tabIndex === 0
                  ? _c(
                      "div",
                      [
                        _c("AwaitingTickets", {
                          attrs: {
                            "show-my-tickets": _vm.showMyTicket,
                            tag: _vm.selectedTopic,
                            statuses: _vm.statuses,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tabIndex === 1
                  ? _c(
                      "div",
                      [
                        _c("TicketHistory", {
                          attrs: {
                            timeSelect: _vm.timeSelect,
                            statuses: _vm.statuses,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tabIndex === 2 &&
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["offlineSupportRequest.get"].tr.name
                )
                  ? _c("div", [_c("TicketForwarding")], 1)
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              staticClass: "ticket-status-form",
              attrs: {
                id: "ticket-status-form",
                "show-footer": false,
                title: _vm.ticketFormMode
                  ? _vm.$t("message.ticketStatusForm")
                  : _vm.$t("message.listStatuses"),
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _vm.ticketFormMode
                ? _c(
                    "div",
                    [
                      _c(
                        "b-form",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleSave.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "message.statusFormTitle"
                                                ),
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  name: _vm.$t(
                                                    "message.statusFormTitle"
                                                  ),
                                                  autocomplete: "off",
                                                  trim: "",
                                                  type: "text",
                                                },
                                                model: {
                                                  value: _vm.statusForm.title,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.statusForm,
                                                      "title",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "statusForm.title",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "12", id: "buttons" } },
                                        [
                                          _c(
                                            "b-button",
                                            { on: { click: _vm.hideModal } },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                type: "submit",
                                                variant: "primary",
                                              },
                                              on: {
                                                submit: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.handleSave.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              !_vm.statusForm._id
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t("message.save")
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.update"
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("StatusTable", {
                        attrs: { statuses: _vm.statuses },
                        on: { edit: _vm.editStatus, deleted: _vm.deleted },
                      }),
                    ],
                    1
                  ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }